$(document).ready(function() {

    $('.mob-burger').click( function() {

        if($(this).hasClass('mob-burger--active')) {

            // Make transition
            $('.nav').removeClass('nav-mob--active');
            $(this).removeClass('mob-burger--active');

            $('body').removeClass('fix-position');

        } else {

            // Add fixed to body
            $('body').addClass('fix-position');
            $(this).addClass('mob-burger--active');

            // Add Z-index
            $('.nav').addClass('nav-mob--active');

        }


    });

});


// WEBPACK FOOTER //
// ./mob-nav.js